export var TypeActionStore;
(function (TypeActionStore) {
    TypeActionStore["BuyPackage"] = "Store > Buy";
    TypeActionStore["BuyPackageRequest"] = "Store > BuyRequest";
    TypeActionStore["ConsumePackage"] = "Store > ConsumePackage";
    TypeActionStore["SelectPackage"] = "Store > SelectPackage";
})(TypeActionStore || (TypeActionStore = {}));
export var actionStoreBuyPackage = function (packageId, amount, cost) { return ({
    amount: amount,
    cost: cost,
    packageId: packageId,
    type: TypeActionStore.BuyPackage,
}); };
export var actionStoreBuyPackageRequest = function (packageId, amount, cost) { return ({
    amount: amount,
    cost: cost,
    packageId: packageId,
    type: TypeActionStore.BuyPackageRequest,
}); };
export var actionStoreSelectPackage = function (packageInfo) { return ({
    packageInfo: packageInfo,
    type: TypeActionStore.SelectPackage,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/store/actionStore.ts
// module id = 308
// module chunks = 3